import { PAYMENTS_TABLE_COLUMNS } from '../constants'

export const paymentDataPreparation = (data, { intl }, combos) => {
  return data.map((item) => {
    const formattedColumns = {}
    PAYMENTS_TABLE_COLUMNS.forEach((column) => {
      if (column.type === 'date' && item[column.field]) {
        formattedColumns[column.field] = intl.formatDate(item[column.field])
      }
    })
    return {
      ...item,
      ...formattedColumns,
      tableData: {
        ...item.tableData,
      },
    }
  })
}
